module.exports = __webpack_public_path__ + "static/media/edit-icon.8ae9f9ab.svg";